import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { DetailPair } from '../../../../../../../shared/components/detail-info-card/DetailPair';
import { DataUtility } from '../../../../../../../utilities/DataUtility';
import { EquifaxDetailCardComponent } from '../equifax-detail-card/equifax-detail-card.component';

@Component({
  selector: 'app-guest-address-result-card',
  templateUrl: './guest-address-result-card.component.html',
  styleUrls: ['./guest-address-result-card.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    EquifaxDetailCardComponent
  ]
})
export class GuestAddressResultCardComponent implements OnInit {

  @Input() guest!: any;

  data: DetailPair[] = [];
  title = 'Address Trust';
  trustDecision!: string;

  addressAffiliationReason!: string;
  addressVerificationReason!: string;
  addressInsightsReason!: string;

  constructor(private dataUtility: DataUtility) { }

  ngOnInit() {
    this.addressAffiliationReason = this.dataUtility.getCheckReason(this.guest, 'addressAffiliationReason');
    this.addressVerificationReason = this.dataUtility.getCheckReason(this.guest, 'addressVerificationReason');
    this.addressInsightsReason = this.dataUtility.getCheckReason(this.guest, 'addressInsightsReason');

    this.populateAddressTrustInfo();
  }

  populateAddressTrustInfo() {
    this.trustDecision = this.dataUtility.getTrustInfo(this.guest, 'addressTrust');

    this.data.push(new DetailPair("Affiliation", this.dataUtility.getTrustInfo(this.guest, 'addressAffiliation') ? this.dataUtility.getTrustInfo(this.guest, 'addressAffiliation') : null, this.addressAffiliationReason));
    this.data.push(new DetailPair("Verification", this.dataUtility.getTrustInfo(this.guest, 'addressVerification') ? this.dataUtility.getTrustInfo(this.guest, 'addressVerification') : null, this.addressVerificationReason));
    this.data.push(new DetailPair("Insights", this.dataUtility.getTrustInfo(this.guest, 'addressInsights') ? this.dataUtility.getTrustInfo(this.guest, 'addressInsights') : null, this.addressInsightsReason));
  }

}